import { useDispatch, useSelector } from 'react-redux'
import { a11ySelector, dropA11yState } from '../../../../redux/slices/a11y'
import ButtonCancel from '../../../reusable/Buttons/ButtonCancel'

const Buttons = () => {
  const { dirty } = useSelector(a11ySelector)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch(dropA11yState())
  }

  return <ButtonCancel title="Скасувати зміни" disabled={!dirty} handler={handleCancel} />
}

export default Buttons
